import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiConfigs } from '../../../api/APIConfigs';
import { Church } from '../../../api/models/Church';
import { UploadResult } from '../../../api/models/UploadResult';
import { routes } from '../../../route-list';
import { useRequest } from '../../../util/use-request';
import { ChurchFormScreen } from '../components/ChurchFormScreen';
import { ChurchFormState, churchInitialFormState } from '../church-form.helper';

/**
 * Why is this not following the same structure as (link below)?
 * https://github.com/smashingboxes/arno/blob/dev/src/modules/home/containers/HomeContainer.tsx
 *
 * Reason 1: Don’t call Hooks inside loops, conditions, or nested functions
 * (https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level)
 * Reason 2: Don’t call Hooks from regular JavaScript functions.
 * (https://reactjs.org/docs/hooks-rules.html#only-call-hooks-from-react-functions)
 */
export const EditChurchContainer = () => {
  const history = useHistory();
  const request = useRequest();
  const { id } = useParams<{ id: string }>();

  const [formState, setFormState] = useState<ChurchFormState>(churchInitialFormState);
  const [isLoading, setIsLoading] = useState(false);
  const [didInit, setDidInit] = useState(false);

  useEffect(() => {
    if (!didInit) {
      setDidInit(true);

      (async () => {
        try {
          setIsLoading(true);
          const result = await request<Church>(apiConfigs.getChurchById(id));

          setFormState({
            name: result.name,
            address: result.address,
            id: result.id,
            phone: result.phone,
            externalId: result.externalId,
            created: result.created,
            logo: result.logo,
          });
        } catch (e) {
          toast.error('Failed to load church!');
        } finally {
          setIsLoading(false);
        }
      })();
    }
  }, [didInit, id, request]);

  return (
    <ChurchFormScreen
      mode="edit"
      formState={formState}
      isLoading={isLoading}
      userUpdatedFormState={setFormState}
      userClickedSaveSection={async () => {
        try {
          setIsLoading(true);

          const payload: Partial<Church> = {
            id: formState.id,
            name: formState.name,
            address: formState.address,
            phone: formState.phone,
          };

          // if (formState.thumbnail) {
          //   const upload = await request<UploadResult>(apiConfigs.uploadImage(formState.thumbnail));
          //   payload.imageUrl = upload.filePath;
          // }

          await request(apiConfigs.updateChurch(id, payload));
          toast.success('Church updated!');
          history.push(routes.CHURCH);
        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      }}
      userClickedCancel={() => {
        history.push(routes.CHURCH);
      }}
    />
  );
};
